import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";

const StyledPagination = styled.div`
  background-color: ${({ theme }) => theme.surface};
  border-radius: 50px;
  padding: 0.5rem 1rem;
`;

const StyledButtonPage = styled.div`
  padding: 0 0.8rem;
  cursor: pointer;
`;

const Pagination = ({ className, table, isFetching }) => {
  return (
    <StyledPagination className={`${className}`}>
      <div className="d-flex align-items-center">
        <StyledButtonPage
          onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
        >
          <FontAwesomeIcon icon={faAngleDoubleLeft} />
        </StyledButtonPage>
        <StyledButtonPage
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </StyledButtonPage>
        <StyledButtonPage
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </StyledButtonPage>
        <StyledButtonPage
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
        >
          <FontAwesomeIcon icon={faAngleDoubleRight} />
        </StyledButtonPage>
        <div className="d-flex ms-4 me-2">
          <div className="me-2">Page</div>
          <strong>
            {table.getState().pagination.pageIndex + 1} of{" "}
            {table.getPageCount()}
          </strong>
        </div>
        {/* <span className="flex items-center gap-1">
          | Go to page:
          <input
            type="number"
            defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              table.setPageIndex(page);
            }}
            className="border p-1 rounded w-16"
          />
        </span> */}
        {/* <select
          value={table.getState().pagination.pageSize}
          onChange={(e) => {
            table.setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}
      </div>
    </StyledPagination>
  );
};

export default Pagination;
